<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="yunPrints"
          >配置云打印</el-button
        >
      </div>
      <div>
        <el-select
          clearable
          size="small"
          filterable
          class="mr10"
          v-model="searchCondition.shopId"
          placeholder="请选择所属门店"
        >
          <el-option
            v-for="(item, i) in expressShopList"
            :key="i"
            :label="item.shopName"
            :value="item.shopId"
          >
          </el-option>
        </el-select>
        <!-- <el-input
          clearable
          style="width:250px"
          v-model.trim="searchCondition.cardName"
          placeholder="请输入发货人/联系人名称/联系人电话"
          size="small"
          class="ipt mr10"
        ></el-input> -->
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="expressPageList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所属门店"
          prop="shopName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cpName"
          label="快递名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="userName"
          label="发货人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="province"
          label="省市区"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.province }}{{ scope.row.city
              }}{{ scope.row.district }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="detail"
          label="详细地址"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="联系人名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="phone"
          label="联系人电话"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer mr10" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="expressPageList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :before-close="handleClose"
      :title="title"
      :visible.sync="yunPrint"
      width="50%"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="134px"
      >
        <el-form-item label="appId" prop="appId">
          <el-input
            clearable
            v-model="ruleForm.appId"
            size="small"
            placeholder="请输入appId(通过快宝获取)"
          ></el-input>
        </el-form-item>
        <el-form-item label="apiKey" prop="apiKey">
          <el-input
            clearable
            v-model="ruleForm.apiKey"
            size="small"
            placeholder="请输入apiKey(通过快宝获取)"
          ></el-input>
        </el-form-item>
        <el-form-item label="agentId" prop="agentId">
          <el-input
            clearable
            v-model="ruleForm.agentId"
            size="small"
            placeholder="请输入agentId(通过快宝获取)"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属门店" prop="shopId">
          <el-select
            clearable
            size="small"
            filterable
            class="mr10"
            v-model="ruleForm.shopId"
            @change="selectShopName"
            placeholder="请选择所属门店"
          >
            <el-option
              v-for="(item, i) in expressShopList"
              :key="i"
              :label="item.shopName"
              :value="item.shopId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递名称" prop="cpCode">
          <el-select
            clearable
            filterable
            @change="selectName"
            v-model="ruleForm.cpCode"
            placeholder="请选择快递"
          >
            <el-option
              v-for="(item, i) in options"
              :key="i"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发货人" prop="userName">
          <el-input
            clearable
            v-model="ruleForm.userName"
            size="small"
            placeholder="请输入发货人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="省市区" prop="citys">
          <el-cascader
            :options="area"
            size="small"
            ref="citys"
            clearable
            placeholder="请选择省市区"
            v-model="ruleForm.citys"
            :props="props"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="detail">
          <el-input
            clearable
            v-model="ruleForm.detail"
            size="small"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="phone">
          <el-input
            clearable
            type="number"
            v-model="ruleForm.phone"
            size="small"
            placeholder="请输入联系人电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人名称" prop="name">
          <el-input
            clearable
            v-model="ruleForm.name"
            size="small"
            placeholder="请输入联系人名称"
          ></el-input>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >确认</el-button
          >
          <el-button size="small" @click="yunPrint = false">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import area from "@/utils/area";
export default {
  components: {},
  data() {
    return {
      area,
      options: [
        {
          value: "YTO",
          label: "圆通快递"
        },
        {
          value: "STO",
          label: "申通快递"
        },
        {
          value: "ZTO",
          label: "中通快递"
        },
        {
          value: "YUNDA",
          label: "韵达快递"
        },
        {
          value: "HTKY",
          label: "百世汇通"
        },
        {
          value: "TTKDEX",
          label: "天天快递"
        },
        {
          value: "EMS",
          label: "EMS标准快递"
        },
        {
          value: "POSTB",
          label: "邮政小包"
        },
        {
          value: "ZJS",
          label: "宅急送"
        },
        {
          value: "UC",
          label: "优速快递"
        },
        {
          value: "GTO",
          label: "国通快递"
        },
        {
          value: "FAST",
          label: "快捷快递"
        },
        {
          value: "DBKD",
          label: "德邦快递"
        },
        {
          value: "QFKD",
          label: "全峰快递"
        },
        {
          value: "SF",
          label: "顺丰快递"
        },
        {
          value: "EYB",
          label: "EMS经济快递"
        },
        {
          value: "100004928",
          label: "如风达"
        },
        {
          value: "5000000007756",
          label: "邮政标准快递"
        },
        {
          value: "BESTQJT",
          label: "百世快递"
        },
        {
          value: "SURE",
          label: "速尔快递"
        },
        {
          value: "CN7000001003751",
          label: "跨越速运"
        },
        {
          value: "2608021499_235",
          label: "安能"
        },
        {
          value: "2383545689_32",
          label: "九曳"
        },
        {
          value: "2460304407_385",
          label: "远成快运"
        },
        {
          value: "3108002701_1011",
          label: "中通快运"
        }
      ],
      title: "",
      currentPage: 1,
      pageSize: 10,
      yunPrint: false,
      searchCondition: {},
      props: {
        value: "label",
        children: "children"
      },
      ruleForm: {
        appId: "",
        apiKey: "",
        agentId: "",
        shopId: "",
        shopName: "",
        cpCode: "",
        cpName: "",
        userName: "",
        citys: "",
        detail: "",
        phone: "",
        name: ""
      },
      rules: {
        appId: [
          {
            required: true,
            message: "请输入appId(通过快宝获取)",
            trigger: "blur"
          }
        ],
        apiKey: [
          {
            required: true,
            message: "请输入apiKey(通过快宝获取)",
            trigger: "blur"
          }
        ],
        agentId: [
          {
            required: true,
            message: "请输入agentId(通过快宝获取)",
            trigger: "blur"
          }
        ],
        shopId: [
          {
            required: true,
            message: "请选择所属门店",
            trigger: "blur"
          }
        ],
        cpCode: [
          {
            required: true,
            message: "请选择快递",
            trigger: "blur"
          }
        ],
        userName: [
          {
            required: true,
            message: "请输入发货人姓名",
            trigger: "blur"
          }
        ],
        citys: [
          {
            required: true,
            message: "请选择省市区",
            trigger: "blur"
          }
        ],
        detail: [
          {
            required: true,
            message: "请输入菜鸟快递编号",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入菜鸟快递编号",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: mapGetters(["expressShopList", "expressPageList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.$store.dispatch("expressShopList");
  },
  methods: {
    selectShopName(val) {
      this.expressShopList.find(v => {
        if (v.shopId === val) {
          this.ruleForm.shopName = v.shopName;
        }
      });
    },
    selectName(val) {
      this.options.find(v => {
        if (v.value === val) {
          this.ruleForm.cpCode = v.value;
          this.ruleForm.cpName = v.label;
        }
      });
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      //   this.searchCondition.printType = "";
      //   this.searchCondition.isSend = "";
      //   if (this.searchCondition.timeStatus === "daipeihuo") {
      //     this.searchCondition.printType = "no";
      //   } else if (this.searchCondition.timeStatus === "daifahuo") {
      //     this.searchCondition.printType = "yes";
      //     this.searchCondition.isSend = "no";
      //   } else if (this.searchCondition.timeStatus === "yifahuo") {
      //     this.searchCondition.printType = "yes";
      //     this.searchCondition.isSend = "yes";
      //   }

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      return this.$store.dispatch("expressPageList", params);
    },
    yunPrints() {
      this.title = "配置云打印";
      this.yunPrint = true;
    },
    handleClose(done) {
      done();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (typeof this.ruleForm.citys === "object") {
            this.ruleForm.province = this.ruleForm.citys[0];
            this.ruleForm.city = this.ruleForm.citys[1];
            this.ruleForm.district = this.ruleForm.citys[2];
          }

          let params = this.ruleForm;

          this.$store
            .dispatch(
              this.title === "配置云打印" ? "expressSave" : "updateExpress",
              params
            )
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                setTimeout(() => {
                  this.resetRuleForm();
                }, 0);
                this.queryList();
                this.yunPrint = false;
              }
            });
        } else {
          return false;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.citys = "";
    },
    edit(row) {
      this.yunPrint = true;
      this.title = "编辑配置云打印";
      row.citys = row.province;
      for (let key in row) {
        this.ruleForm[key] = row[key];
      }
      let city = row.province + row.city + row.district;
      setTimeout(() => {
        if (this.$refs.citys) {
          this.$refs.citys.presentText = city;
        }
      }, 0);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
